import { track, page } from './analytics'

export function pageViewed() {
  return page('Upgrade Flow', {})
}

export function upgradeCTAClicked({
  billingTier,
  currentURL,
  position,
  workspaceId,
  workspaceSlug
}) {
  return track('Upgrade CTA Clicked', {
    workspace_id: workspaceId,
    workspace_slug: workspaceSlug,
    billing_tier: billingTier,
    position,
    current_url: currentURL
  })
}

export function subscriptionPlanChanged({
  workspaceId,
  previousPlan,
  newPlan,
  version = null
}) {
  window.analytics.track('Subscription Plan Changed', {
    workspaceId,
    previousPlan,
    newPlan,
    version
  })
}

export function subscriptionPlanFailed({
  workspaceId,
  newPlan,
  previousPlan,
  version = null
}) {
  window.analytics.track('Subscription Plan Failed', {
    workspaceId,
    newPlan,
    previousPlan,
    version
  })
}
